import { render, staticRenderFns } from "./altitudeControll.vue?vue&type=template&id=49561610&scoped=true&"
import script from "./altitudeControll.vue?vue&type=script&lang=js&"
export * from "./altitudeControll.vue?vue&type=script&lang=js&"
import style0 from "./altitudeControll.vue?vue&type=style&index=0&id=49561610&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49561610",
  null
  
)

export default component.exports